import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);
  return {
    get,
    save,
    clear
  };

  function save(hash, body) {
    return axiosInstance.put("car-details/marketing-property/" + hash, body).then(r => r.data);
  }

  function get(hash) {
    return axiosInstance.get("car-details/marketing-property/" + hash).then(r => r.data);
  }
  /**
   * Clears property value by setting it to null
   * @param id id of the property to clear, do not confuse with `MarketingProperty.propertyId`
   */


  async function clear(id) {
    await axiosInstance.patch("car-details/marketing-property/" + id, [{
      op: 'replace',
      path: '/value',
      value: ''
    }], {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    });
  }
}